import PropTypes from 'prop-types';
import { MEMBER_GROUP_TYPES } from './utils';
import { MessageTypes } from './components/WizardWarningMessage';

export const SectionPermissionSchema = PropTypes.shape({
    access_type: PropTypes.number.isRequired,
    display_name: PropTypes.string.isRequired,
    feature_name: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    ui_key: PropTypes.string.isRequired,
});

export const RoleSchema = PropTypes.shape({
    column: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    features: PropTypes.shape({
        access_new_features: PropTypes.bool.isRequired,
        values: PropTypes.arrayOf(PropTypes.string).isRequired,
    }).isRequired,
    modified: PropTypes.string.isRequired,
    modified_by: PropTypes.string,
    org_access: PropTypes.number,
    row: PropTypes.arrayOf(
        PropTypes.shape({
            dimension: PropTypes.string.isRequired,
            operator: PropTypes.string.isRequired,
            values: PropTypes.arrayOf(PropTypes.string).isRequired,
        })
    ).isRequired,
    sectionPermissions: PropTypes.arrayOf(SectionPermissionSchema).isRequired,
    type: PropTypes.number.isRequired,
});

export const AgencyMemberSchema = PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    deletable: PropTypes.bool.isRequired,
    imgSrc: PropTypes.string,
    role: RoleSchema,
    searchText: PropTypes.string.isRequired,
});

export const UserMemberSchema = PropTypes.shape({
    user_id: PropTypes.number.isRequired,
    username: PropTypes.string.isRequired,
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    user_picture: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    mfa_activated: PropTypes.bool.isRequired,
    created_at: PropTypes.string.isRequired,
    role_type: PropTypes.number.isRequired,
    last_login: PropTypes.string,
    first_login: PropTypes.string,
    is_admin: PropTypes.bool.isRequired,
    is_org_admin: PropTypes.bool.isRequired,
    is_slack_auth: PropTypes.bool.isRequired,
    organization_user_id: PropTypes.number.isRequired,
    is_active: PropTypes.bool.isRequired,
    is_poc: PropTypes.bool.isRequired,
    show_controls: PropTypes.bool.isRequired,
    is_restricted: PropTypes.bool.isRequired,
    role: RoleSchema,
    id: PropTypes.number.isRequired,
    isMe: PropTypes.bool.isRequired,
    name: PropTypes.string,
    description: PropTypes.string,
    roleText: PropTypes.string,
    searchText: PropTypes.string,
    deletable: PropTypes.bool.isRequired,
    disabledTootlip: PropTypes.string,
});

export const InvitedMemberSchema = PropTypes.shape({
    invite_id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    user_picture: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
    last_re_invited_at: PropTypes.number.isRequired,
    role: RoleSchema,
    id: PropTypes.string.isRequired,
    isMe: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    roleText: PropTypes.string.isRequired,
    searchText: PropTypes.string.isRequired,
    deletable: PropTypes.bool.isRequired,
    disabledTootlip: PropTypes.string,
});

export const MembersByGroupSchema = PropTypes.shape({
    active: PropTypes.arrayOf(PropTypes.oneOf([UserMemberSchema, AgencyMemberSchema])),
    inactive: PropTypes.arrayOf(PropTypes.oneOf([UserMemberSchema, AgencyMemberSchema])),
    pending: PropTypes.arrayOf(InvitedMemberSchema),
});

export const MembersGroupsSchema = PropTypes.arrayOf(
    PropTypes.shape({
        name: PropTypes.oneOf(Object.values(MEMBER_GROUP_TYPES)).isRequired,
        displayName: PropTypes.string.isRequired,
        infoMessages: PropTypes.arrayOf(
            PropTypes.shape({
                message: PropTypes.string.isRequired,
                type: PropTypes.oneOf(Object.values(MessageTypes)).isRequired,
            })
        ).isRequired,
    })
);

export const ItemSchema = PropTypes.shape({
    name: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    selected: PropTypes.bool.isRequired,
    Icon: PropTypes.elementType,
    icon: PropTypes.string.isRequired,
    extra: PropTypes.element,
    disabled: PropTypes.bool,
});

export const PartnerSchema = PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
});
